// Copyright 2019 Sorama B.V.

import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { TimelineEntryType } from "datatypes/SoramaWebApi";
import { Browser } from "libraries/MediaQueries/MediaQueries";
import { IWorkflowMode } from "services/WorkflowModes/IWorkflowMode";

export enum WorkflowModuleType {
    /**
     * All Modules that support manipulating streaming modules
     */
    StreamingSettings = "Streaming Settings",
    /**
     * All modules that can visualize streaming results
     */
    Streaming = "Streaming",
    Analysis = "Analysis",
    GenericAnalysis = "Generic Analysis",
    NearFieldAnalysis = "Near-Field Analysis",
    FarFieldAnalysis = "Far-Field Analysis",
    PsychoAcousticsAnalysis = "Psychoacoustics Analysis",
    Management = "Management",
    Measurement = "Measurement",
    Project = "Project",
    Presentation = "Presentation",
    Journal = "Journal",
    MeasurementSetup = "Measurement Setup",
    Debug = "Debug",
    Client = "Client",
    User = "User",
    Help = "Help",
    HelpContainer = "HelpContainer",
    Report = "Report",
    Reporting = "Reporting",
    SriReport = "SriReport",
}

export class WorkflowModuleTypes {
    public static AllAnalysis: WorkflowModuleType[] = [
        WorkflowModuleType.GenericAnalysis,
        WorkflowModuleType.FarFieldAnalysis,
        WorkflowModuleType.NearFieldAnalysis,
        WorkflowModuleType.PsychoAcousticsAnalysis,
    ];

    public static PsychoAcousticAnalysis: WorkflowModuleType[] = [WorkflowModuleType.GenericAnalysis];
}

/**
 * A description of a module and which files to load
 */
export interface IWorkflowModuleConfig {
    /**
     * Unique module name, used for URL generation
     **/
    name: string;

    /**
     * Path to the module
     */
    modulePath: string;

    /**
     * Used for help and shown above in a module
     */
    title: string;

    icon?: string;
    isFullScreen?: boolean;
    moduleType: WorkflowModuleType;

    help?: IGuidanceTopic;

    /**
     * If this property is defined, a user can click on the like/star button on top to highlight the current module in a timeline entry
     */
    timelineEventType?: TimelineEntryType;

    /**
     * If this module requires the acquisition client to be connected
     */
    requireClient?: boolean;
    requireSignIn?: boolean;
    requireOnline?: boolean;
    requireStreaming?: boolean;

    disableForWorkflowModes?: IWorkflowMode[];

    canExtend?: boolean;
    canCollapse?: boolean;
    isDefaultExtended?: boolean;

    /**
     * User cannot close the module
     */
    isInadmissible?: boolean;

    /**
     * Module will show an error for this module when the excluded browser is used.
     */
    excludedBrowser?: Browser[];

    recommended?: boolean;

    /**
     * If true, the module will be disabled and not shown in the module list
     */
    isDisabled?: boolean;
    disabledReason?: string;
}
